import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class HttpService {
  constructor(protected logger?: NGXLogger) { }

  /**
   * Returns the correct API endpoint based on SAP/ARP logic.
   * @param arpOrigin Origin URL for ARP
   * @param arpUsap SAP/ARP identifier
   * @param aomEndPoint Default endpoint
   */
  public getAPIEndPoint(arpOrigin: string, arpUsap: string, aomEndPoint: string): string {
    return (arpUsap ? (arpOrigin+'/') : aomEndPoint );
  }

  public getUsap(arpSap: string, aomSap: string) {
    return ((arpSap ? arpSap : aomSap) + "/")
  }

  protected extractData(res: any) {
    let body: any;
    if (res) {
      body = res;
    }
    return body || {};
  }

  protected handleError(error: HttpErrorResponse | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    let infoMsg: any[];
    let code: string = '';
    let key: string = '';
    let type: string = '';
    let officeDetails: any;
    let certificate: any[];
    let terminal: any[];
    let printer: any[];
    let setList: any[];
    let draftId: any;
    let permissions: any;
    let meta: any;
    let warnings: any;
    try {
      if (error instanceof HttpErrorResponse) {
        let errorObject: any = error.error;
        if (typeof (errorObject) !== 'object') {
          errorObject = JSON.parse(errorObject);
        }
        errMsg = errorObject.errors || errorObject.error || '';
        if (errorObject.Message || errorObject.message) {
          errMsg = errorObject.Message ? errorObject.Message : errorObject.message;
        }
        if (errorObject.Code || errorObject.code) {
          code = errorObject.Code ? errorObject.Code : errorObject.code;
        }
        if (errorObject.Key || errorObject.key) {
          key = errorObject.Key ? errorObject.Key : errorObject.key;
        }
        if (errorObject.ContentType) {
          type = errorObject.ContentType;
        }
        if (errorObject.draftId) {
          draftId = errorObject.draftId;
        }
        if (errorObject.certificate) {
          certificate = errorObject.certificate;
        }
        if (errorObject.printer) {
          printer = errorObject.printer;
        }
        if (errorObject.set) {
          setList = errorObject.set;
        }
        if (errorObject.terminal) {
          terminal = errorObject.terminal;
        }
        if (errorObject.officeDetails) {
          officeDetails = errorObject.officeDetails;
        }
        if (errorObject.permissions) {
          permissions = errorObject.permissions;
        }
        if (errorObject.meta) {
          meta = errorObject.meta;
        }
        if (errorObject.warnings) {
          warnings = errorObject.warnings;
        }
        if (errorObject.information) {
          infoMsg = errorObject.information;
        }
      } else if (error.message || error.Message) {
        // incase of timeout message will `Timeout has occurred`
        errMsg = error.message ? error.message : error.Message;
      } else {
        errMsg = '';
      }
    } catch (e) {
      if (this.logger) {
        this.logger.error(e);
      }
    }
    let errorObj: any = {
      status: error.status,
      code,
      key,
      type,
      message: errMsg,
      certificate,
      printer,
      setList,
      terminal,
      officeDetails,
      draftId,
      permissions,
      meta,
      warnings,
      information: infoMsg
    };

    if (this.logger) {
      this.logger.error(errorObj);
    }
    return throwError(errorObj);
  }
  protected handleUpdateError(error: HttpErrorResponse | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errors: any[] = [];
    let draftId: any;
    let parameter: any;
    if (error instanceof HttpErrorResponse) {
      let errorObject: any = error.error;
      if (typeof (errorObject) !== 'object') {
        errorObject = JSON.parse(errorObject);
      }
      const httpErrorObj = errorObject.errors || errorObject.validationError
        || errorObject.error || '';
      for (let errorBlock of httpErrorObj) {
        errors.push(errorBlock);
      }
      if (errorObject.draftId) {
        draftId = errorObject.draftId;
      }
      if (errorObject.parameter) {
        parameter = errorObject.parameter;
      }
    }
    let errorObj: any = {
      status: error.status,
      errors,
      draftId,
      parameter
    };
    if (this.logger) {
      this.logger.error(errorObj);
    }
    return throwError(errorObj);
  }
}